export default {
    path: 'issuing_agent',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/IssuingAgent/IssuingAgentList'),
    meta: { title: '个人发票税务代开' },
}